import hamsClient from 'modules/hams';
import type { TaxRate } from 'modules/data/taxRates/model';

export default async (countryCode: string, stateKey: string): Promise<TaxRate> =>
  (
    await hamsClient.get(`1.0/public/order/taxrate/${countryCode}`, {
      params: { stateKey },
    })
  ).data;
